import React from 'react';
import Graph from './graph';

export default function Monitored({ href, bin }) {
  return (
    <>
      <h3>Level History</h3>
      <Graph href={href} role={bin.properties.role} />
    </>
  );
}
